<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <StationInfo ref="info" :bus-item="repairItem"></StationInfo>

    <div v-if="tips" style="margin:20px;color: red;padding-left: 130px">
      {{ tips }}
    </div>

    <el-row v-if="componentParam === 'repair_oqc'">
      <div style="margin: 10px 0 0 80px;">指导照片</div>
      <div style="margin: 10px 0 0 15px;">
        <KfImageViewer :imageList="this.imageList"/>
      </div>
    </el-row>

    <div style="margin: 10px 0 0 8px">
      <FrameForm ref="frameForm" :component-param="componentParam"
                 :parent-data="{id:repairItem.id,station_id:stationId}"></FrameForm>
    </div>
  </div>
</template>

<script>
import StationInfo from "@/views/applications/repair/StationInfo.vue";

export default {
  name: "StationParent",
  components: {StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      sn: '',
      canWork: false,
      loading: false,
      repairItem: {},
      tips: '',
      imageList: [],
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 7) {
        return this.componentParam.substring(7);
      }
      return '';
    }
  },
  provide() {
    return {
      $fn: {
        reset: () => {
          this.sn = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    search() {
      let next_station_user_id = this.$refs.frameForm.formInfo.next_station_user_id
      let remark = this.$refs.frameForm.formInfo.remark

      this.reset()

      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('repairItemService.queryStationInfo', {
        station_id: this.stationId,
        sn: this.sn
      }, false).then(async data => {
        this.loading = false
        this.repairItem = data.repairItem || {}
        this.tips = data.tips
        this.imageList = data.imageList
        this.canWork = true
        await this.$refs.frameForm.initForm()
        if (this.stationId === 'assign') {
          this.$refs.frameForm.formInfo.next_station_user_id = next_station_user_id;
          this.$refs.frameForm.formInfo.remark = remark;
        }
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        if (this.stationId === 'assign') {
          this.$refs.frameForm.formInfo.next_station_user_id = next_station_user_id;
          this.$refs.frameForm.formInfo.remark = remark;
        }
        return this.$refs.searchMessage.showError(errMsg)
      })


    },
    reset() {
      this.repairItem = {}
      this.canWork = false
      this.$refs.searchMessage.clear()

    }
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}
</style>